export const monitoringConfig = Object.freeze({
  cameraHealth: {
    sampleIntervalMs: 1_250,
    sampleWidthPx: 32,
    sampleHeightPx: 18,
    startupGracePeriodMs: 5_000,
    frozenFrameDifferenceThreshold: 1.2,
    meaningfulFrameDifferenceThreshold: 3.5,
    frozenFrameConfirmationMs: 8_000,
    darkLuminanceThreshold: 30,
    darkFrameConfirmationMs: 5_000,
    brightLuminanceThreshold: 242,
    brightFrameConfirmationMs: 5_000,
    obstructionLuminanceThreshold: 12,
    obstructionVarianceThreshold: 5,
    obstructionConfirmationMs: 4_000,
    recoveryConfirmationMs: 3_000
  },
  candidatePresence: {
    sampleIntervalMs: 1_500,
    analysisWidthPx: 160,
    analysisHeightPx: 90,
    startupGracePeriodMs: 5_000,
    requiredConsecutiveAbsentSamples: 3,
    absenceConfirmationMs: 7_500,
    requiredConsecutivePresentSamples: 2,
    recoveryDurationMs: 3_000,
    detectorRetryDelayMs: 2_500,
    maximumConsecutiveDetectorFailures: 3,
    capabilityRecoveryRetryMs: 15_000,
    detectionTimeoutMs: 5_000
  },
  cameraMovement: {
    baselineWarmupDurationMs: 6_000,
    baselineSampleCount: 5,
    warmupStructuralNoiseThreshold: 4,
    activationScoreThreshold: 12,
    structuralChangeThreshold: 8,
    consecutiveSampleRequirement: 3,
    movementConfirmationMs: 2_500,
    recoveryScoreThreshold: 6,
    recoveryStructuralThreshold: 3.5,
    recoveryDurationMs: 5_000,
    rebaselineDelayMs: 2_500,
    cameraSwitchGraceMs: 7_500,
    reconnectGraceMs: 8_000
  },
  connection: {
    disconnectGracePeriodMs: 4_000,
    reconnectConfirmationMs: 2_500,
    degradedStateTimeoutMs: 8_000
  },
  timeline: {
    deduplicationWindowMs: 12_000,
    maximumActiveObservations: 12,
    maximumCompletedObservations: 120,
    sameEventMergeIntervalMs: 15_000
  },
  warnings: {
    cooldownMs: 12_000
  }
});

export type MonitoringConfig = typeof monitoringConfig;
